<template>
  <w-icon-wrapper icon-name='work-down-icon'>
    <g
      id='_49_Down_Icon'
      data-name='49 Down_Icon'
      transform='translate(24) rotate(90)'
    >
      <g
        id='Gruppe_25438'
        data-name='Gruppe 25438'
      >
        <path
          id='Pfad_55737'
          d='M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z'
          data-name='Pfad 55737'
          fill='currentColor'
        />
      </g>
      <path
        id='Pfad_55738'
        d='M14.73,3.341a.945.945,0,0,0-.077-.078L11.71.3A1,1,0,1,0,10.29,1.7L11.575,3H1A1,1,0,0,0,1,5H11.56L10.24,6.284a1,1,0,0,0,1.4,1.434l3.787-3.68Z'
        data-name='Pfad 55738'
        fill='currentColor'
        transform='translate(4.289 7.999)'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDown' };
</script>
